/** Receipt / proforma / kitchen print uses English labels and Western digit grouping. */
export const BILL_NUMBER_LOCALE = "en-US";

export function formatBillAmount(n: number): string {
  return n.toLocaleString(BILL_NUMBER_LOCALE);
}

/** Normalize legacy Lao discount labels stored on orders before print. */
export function formatDiscountLabelForBill(label: string): string {
  return label
    .replace(/^ແລກລາງວັນ:\s*/u, "Reward: ")
    .replace(/^ໂຄດສ່ວນຫຼຸດ:\s*/u, "Discount: ");
}
